import clsx from 'clsx';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

function FormGroup(props: Props) {
  let className = clsx('flex flex-col space-y-2.5 mb-3', props.className);

  return (
    <div {...props} className={className}>
      {props.children}
    </div>
  );
}

export default FormGroup;
